import { DASHBOARD_COPY } from './dashboardCopy';

/**
 * The dashboard's sections, one route each (Leo, 2026-09-20). A section link
 * in the header opens that page; nothing scrolls.
 */
export type DashboardSection = 'status' | 'usage' | 'trust' | 'audit' | 'api-key';

export const DASHBOARD_SECTIONS: readonly DashboardSection[] = [
  'status',
  'usage',
  'trust',
  'audit',
  'api-key',
];

/** Route path for a section; Status is the root. */
export const sectionPath = (section: DashboardSection): string =>
  section === 'status' ? '/' : `/${section}`;

/** Section for the first path segment; unknown segments read as Status. */
export const sectionFromPath = (pathname: string): DashboardSection => {
  const first = pathname.split('/').filter(Boolean)[0];
  return (DASHBOARD_SECTIONS as readonly string[]).includes(first ?? '')
    ? (first as DashboardSection)
    : 'status';
};

/** The header's link labels, in AppShell's order: the sections, then Docs.
    The page skeleton sizes one placeholder per label (DASH-003). */
export const NAV_PLACEHOLDER_LABELS: readonly string[] = [
  ...DASHBOARD_SECTIONS.map((id) => DASHBOARD_COPY.navSections[id]),
  DASHBOARD_COPY.navDocs,
];
